"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useQuotationStore = void 0;
/* eslint-disable no-useless-catch */
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const getDefaultState = () => ({
    loading: false,
    quotations: [],
    totalQuotations: 0,
});
exports.useQuotationStore = (0, pinia_1.defineStore)("quotationStore", {
    state: () => getDefaultState(),
    actions: {
        async getQuotations(router, query, quotationId) {
            this.loading = true;
            let url;
            try {
                if (quotationId) {
                    url = router.resolve({
                        name: "quotations_api",
                        query: query,
                        params: { id: quotationId }
                    }).href;
                }
                else {
                    url = router.resolve({
                        name: "quotations_api",
                        query: query
                    }).href;
                }
                const response = await (0, fetch_1.default)(url);
                let quotations = [];
                if (Array.isArray(response["hydra:member"])) {
                    response["hydra:member"].forEach((element) => {
                        if (element["@type"] === "Quotation") {
                            quotations.push(element);
                        }
                    });
                }
                this.quotations = quotations;
                this.totalQuotations = response['hydra:totalItems'];
                return response;
            }
            catch (error) {
                throw error;
            }
            finally {
                this.loading = false;
            }
        },
        async createQuotation(router, request, cartId) {
            this.loading = true;
            const options = { method: 'POST', body: JSON.stringify(request) };
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "create_quotation_api", params: { id: cartId } }).href, options);
                return response;
            }
            catch (error) {
                throw error;
            }
            finally {
                this.loading = false;
            }
        },
        viewPdf(router, quotationId) {
            const url = router.resolve({ name: "quotation_pdf_api", params: { id: quotationId } }).href;
            window.open(url, "_blank");
        },
        resetState() {
            this.$state = { ...getDefaultState() };
        }
    }
});
